import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

import { useGetProjectQuery } from "../../../app/services/projects";
import { useGetCurrentUserQuery } from "../../../app/accounts/authuser";
import { useProjectFieldSync } from "../../../hooks/useProjectFieldSync";
import GuideImage from "../../../components/guide-image/GuideImage";
import TitleBlock from "../../../components/block/TitleBlock";
import Input from "../../../components/form-item/Input";
import StatusIndicator from "../../../components/status-indicator/StatusIndicator";
import SvgLoadingAnimation from "../../../components/loading/index";

const ProjectFinalWork = () => {
  const { projectId } = useParams();
  const { data: currentUserData } = useGetCurrentUserQuery();
  const { data: projectData, isLoading } = useGetProjectQuery(
    { project_id: projectId },
    { skip: !projectId || !currentUserData }
  );
  const { updateStatus, debouncedSave } = useProjectFieldSync(projectId);

  const [finalWork, setFinalWork] = useState("");
  const isComposingRef = useRef(false);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!initializedRef.current && projectData?.data?.project) {
      setFinalWork(projectData.data.project.final_work || "");
      initializedRef.current = true;
    }
  }, [projectData]);

  const handleChange = (e) => {
    const value = e.target.value;
    setFinalWork(value);
    if (!isComposingRef.current) {
      debouncedSave({ final_work: value });
    }
  };

  const handleCompositionStart = () => { isComposingRef.current = true; };
  const handleCompositionEnd = (e) => {
    isComposingRef.current = false;
    const value = e.target.value;
    setFinalWork(value);
    debouncedSave({ final_work: value });
  };

  if (isLoading) return <SvgLoadingAnimation />;

  return (
    <div className="u-col u-w100 u-gap16">
      <TitleBlock
        title="目的物"
        description="プロジェクトの目的物を設定できます。ここで設定した内容は個別契約書に反映され、参加メンバーに、成果物に期待される品質基準やその利用方法を示します。"
      />
      <GuideImage name="project_object" />
      <Input
        type="text"
        label="目的物"
        option="required"
        placeholder="サウンドロゴ制作"
        width="100%"
        maxlength={256}
        name="final_work"
        value={finalWork}
        onChange={handleChange}
        onCompositionStart={handleCompositionStart}
        onCompositionEnd={handleCompositionEnd}
      />
      <StatusIndicator status={updateStatus} />
    </div>
  );
};

export default ProjectFinalWork;
